import React from 'react';

import { useWideScreen } from '../../hooks/useWide';
import { FaqStyled } from './Faq.styled';

interface Props {
  tabSelect: string;
  onTabChange: (customer: string) => void;
  customer: string;
}

export const Tab = (props: Props) => {
  const isWideScreen = useWideScreen();
  const style = {
    background: props.customer === props.tabSelect ? '#f0f1f2' : '#ffffff',
    borderColor: props.customer === props.tabSelect ? '#f0f1f2' : '#DDDEE0',
    '&:hover': {
      background: props.customer !== props.tabSelect ? '#f0f1f2' : '#ffffff'
    }
  };

  return (
    <div
      onClick={() => {
        props.onTabChange(props.customer);
      }}
    >
      <FaqStyled.Tab selected={props.customer === props.tabSelect}>
        <img
          height={32}
          width={32}
          src={require('../../assets/' + props.customer + '.svg')}
        />
        {isWideScreen && (
          <FaqStyled.TabTitle>{props.customer}</FaqStyled.TabTitle>
        )}
      </FaqStyled.Tab>
    </div>
  );
};
